(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sst-main-collection"] && !Shopify.designMode) return;
  try {
    
  (() => {
    if (window.__sstCollectionAjaxInit) return;
    window.__sstCollectionAjaxInit = true;

    const rootSelector = '[data-sst-collection-root]';
    const formSelector = '[data-sst-collection-form]';

    const getRootFromNode = (node) => node?.closest(rootSelector);

    const setLoading = (root, isLoading) => {
      if (!root) return;
      root.classList.toggle('is-loading', isLoading);
      root.setAttribute('aria-busy', isLoading ? 'true' : 'false');
    };

    const serializeForm = (form) => {
      const params = new URLSearchParams(new FormData(form));
      params.delete('page');
      if (!params.get('sort_by')) params.delete('sort_by');
      return params;
    };

    const parseNextRoot = (html, sectionId) => {
      const doc = new DOMParser().parseFromString(html, 'text/html');
      let nextRoot = doc.querySelector(`${rootSelector}[data-section-id="${sectionId}"]`);

      if (nextRoot) return nextRoot;

      const wrapper = document.createElement('div');
      wrapper.innerHTML = html;
      nextRoot = wrapper.querySelector(`${rootSelector}[data-section-id="${sectionId}"]`);
      return nextRoot || wrapper.querySelector('.sst-main-collection');
    };

    const fetchAndSwap = async (root, url, pushHistory = true) => {
      if (!root) return;

      const sectionId = root.getAttribute('data-section-id');
      if (!sectionId) return;

      setLoading(root, true);

      try {
        const renderUrl = new URL(url.toString(), window.location.origin);
        renderUrl.searchParams.delete('section_id');
        renderUrl.searchParams.set('section_id', sectionId);

        const response = await fetch(renderUrl.toString(), {
          headers: { 'X-Requested-With': 'XMLHttpRequest' }
        });
        if (!response.ok) throw new Error('Collection request failed');

        const html = await response.text();
        const nextRoot = parseNextRoot(html, sectionId);
        if (!nextRoot) throw new Error('Collection section parse failed');

        root.replaceWith(nextRoot);
        if (pushHistory) {
          window.history.pushState({ url: url.toString() }, '', url.toString());
        }
      } catch (error) {
        window.location.href = url.toString();
      }
    };

    document.addEventListener('submit', (event) => {
      const form = event.target;
      if (!(form instanceof HTMLFormElement) || !form.matches(formSelector)) return;

      event.preventDefault();
      const root = getRootFromNode(form);
      const url = new URL(form.action || window.location.pathname, window.location.origin);
      const params = serializeForm(form);
      url.search = params.toString();
      fetchAndSwap(root, url, true);
    });

    document.addEventListener('change', (event) => {
      const target = event.target;
      if (!(target instanceof HTMLElement)) return;

      const form = target.closest(formSelector);
      if (!(form instanceof HTMLFormElement)) return;

      if (target.matches('select[name="sort_by"], input[type="checkbox"], input[name^="filter.v.price."]')) {
        form.requestSubmit();
      }
    });

    document.addEventListener('click', (event) => {
      const target = event.target;
      if (!(target instanceof HTMLElement)) return;

      const groupTitle = target.closest('.filter-group-title');
      if (groupTitle instanceof HTMLElement) {
        const group = groupTitle.closest('.filter-group');
        if (group instanceof HTMLElement) {
          group.classList.toggle('is-collapsed');
        }
        return;
      }

      const link = target.closest('.active-filter-chip, .clear-filters-btn, .pagination-wrapper a');
      if (!(link instanceof HTMLAnchorElement)) return;

      const root = getRootFromNode(link);
      if (!root) return;

      const url = new URL(link.href, window.location.origin);
      if (url.origin !== window.location.origin) return;

      event.preventDefault();
      fetchAndSwap(root, url, true);
    });

    window.addEventListener('popstate', () => {
      const root = document.querySelector(rootSelector);
      if (!(root instanceof HTMLElement)) return;
      fetchAndSwap(root, new URL(window.location.href), false);
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
